import { httpClient } from "./client";
import type { components } from "../types/generated";

export type MeasurementSystem = components["schemas"]["UiPreferencesPatch"]["measurement_system"];
export type UiPreferencesResponse = components["schemas"]["UiPreferencesResponse"];

export const preferencesApi = {
  get: () => httpClient.get<UiPreferencesResponse>("/users/me/ui-preferences"),
  setMeasurementSystem: (measurement_system: MeasurementSystem) =>
    httpClient.patch<UiPreferencesResponse>("/users/me/ui-preferences", { measurement_system }),
};
